export const APPLINK = {
    "1":{"apptype":"launch"},
    "2":{"apptype":"print","design_id":"21-11","angle":"0","media_type":"0","media_size":"0"},
    "3":{"apptype":"print","design_id":"03-01","angle":"0","media_type":"0","media_size":"0"},
    "4":{"apptype":"print","design_id":"01-02","angle":"0","media_type":"0","media_size":"0"},
    "5":{"apptype":"print","design_id":"04-03","angle":"0","media_type":"0","media_size":"0"},
    "6":{"apptype":"print","design_id":"41-11","angle":"0","media_type":"0","media_size":"0"},
    "7":{"apptype":"print","design_id":"12-01","angle":"0","media_type":"0","media_size":"0"},
    "8":{"apptype":"print","design_id":"01-01","angle":"0","media_type":"0","media_size":"0"},
    "9":{"apptype":"print","design_id":"06-02","angle":"0","media_type":"0","media_size":"0"},
    "10":{"apptype":"print","design_id":"13-01","angle":"0","media_type":"0","media_size":"0"},
    "11":{"apptype":"print","design_id":"03-02","angle":"0","media_type":"0","media_size":"0"},
    "12":{"apptype":"print","design_id":"31-21","angle":"0","media_type":"0","media_size":"0"},
    "13":{"apptype":"print","design_id":"13-11","angle":"0","media_type":"0","media_size":"0"},
    "14":{"apptype":"print","design_id":"04-03","angle":"0","media_type":"0","media_size":"0"},
    "15":{"apptype":"print","design_id":"12-01","angle":"0","media_type":"0","media_size":"0"},
    "16":{"apptype":"print","design_id":"04-02","angle":"0","media_type":"0","media_size":"0"},
    "17":{"apptype":"print","design_id":"06-02","angle":"0","media_type":"0","media_size":"0"},
    "18":{"apptype":"print","design_id":"04-02","angle":"0","media_type":"0","media_size":"0"},
    "19":{"apptype":"print","design_id":"32-12","angle":"0","media_type":"0","media_size":"0"},
    "20":{"apptype":"print","design_id":"32-11","angle":"0","media_type":"0","media_size":"0"},
    "21":{"apptype":"print","design_id":"02-01","angle":"0","media_type":"0","media_size":"0"},
    "22":{"apptype":"print","design_id":"01-05","angle":"0","media_type":"0","media_size":"0"},
    "23":{"apptype":"launch"},
    "24":{"apptype":"launch"},
    "25":{"apptype":"launch"},
    "26":{"apptype":"print","design_id":"31-01","angle":"0","media_type":"0","media_size":"0"},
    "28":{"apptype":"print","design_id":"12-01","angle":"0","media_type":"0","media_size":"0"},
    "29":{"apptype":"print","design_id":"04-03","angle":"0","media_type":"0","media_size":"0"},
    "30":{"apptype":"print","design_id":"04-04","angle":"0","media_type":"0","media_size":"0"},
    "31":{"apptype":"print","design_id":"04-03","angle":"0","media_type":"0","media_size":"0"},
    "32":{"apptype":"print","design_id":"41-01","angle":"0","media_type":"0","media_size":"0"},
    "33":{"apptype":"print","design_id":"13-01","angle":"0","media_type":"0","media_size":"0"},
    "34":{"apptype":"print","design_id":"12-02","angle":"0","media_type":"28","media_size":"16"},
    "35":{"apptype":"print","design_id":"31-31","angle":"0","media_type":"0","media_size":"0"},
    "36":{"apptype":"print","design_id":"41-01","angle":"0","media_type":"0","media_size":"0"},
    "38":{"apptype":"print","design_id":"13-01","angle":"0","media_type":"0","media_size":"0"},
    "39":{"apptype":"print","design_id":"51-31","angle":"0","media_type":"0","media_size":"0"},
    "40":{"apptype":"print","design_id":"55-01","angle":"0","media_type":"0","media_size":"0"},
    "41":{"apptype":"launch"},
    "42":{"apptype":"print","design_id":"59-01","angle":"90","media_type":"0","media_size":"0"},
    "44":{"apptype":"launch"},
    "46":{"apptype":"print","design_id":"03-03","angle":"0","media_type":"0","media_size":"0"},
    "47":{"apptype":"print","design_id":"51-11","angle":"0","media_type":"0","media_size":"0"},
    "48":{"apptype":"print","design_id":"51-21","angle":"0","media_type":"11","media_size":"0"},
    "49":{"apptype":"launch"},
    "50":{"apptype":"print","design_id":"55-12","angle":"0","media_type":"0","media_size":"0"},
    "51":{"apptype":"print","design_id":"54-01","angle":"0","media_type":"0","media_size":"0"},
    "52":{"apptype":"print","design_id":"51-32","angle":"0","media_type":"0","media_size":"0"},
    "53":{"apptype":"print","design_id":"04-01","angle":"0","media_type":"0","media_size":"0"},
    "54":{"apptype":"print","design_id":"52-01","angle":"0","media_type":"0","media_size":"0"},
    "55":{"apptype":"print","design_id":"52-11","angle":"0","media_type":"0","media_size":"0"},
    "56":{"apptype":"launch"},
    "58":{"apptype":"print","design_id":"41-02","angle":"90","media_type":"0","media_size":"0"},
    "59":{"apptype":"launch"},
    "60":{"apptype":"print","design_id":"02-01","angle":"0","media_type":"0","media_size":"0"},
    "62":{"apptype":"print","design_id":"01-02","angle":"0","media_type":"0","media_size":"0"},
    "63":{"apptype":"print","design_id":"01-02","angle":"0","media_type":"0","media_size":"0"},
    "64":{"apptype":"print","design_id":"03-02","angle":"0","media_type":"0","media_size":"0"},
    "65":{"apptype":"print","design_id":"04-01","angle":"0","media_type":"0","media_size":"0"},
    "66":{"apptype":"print","design_id":"04-01","angle":"0","media_type":"0","media_size":"0"},
    "67":{"apptype":"print","design_id":"31-01","angle":"0","media_type":"0","media_size":"0"},
    "68":{"apptype":"print","design_id":"01-53","angle":"0","media_type":"0","media_size":"0"},
    "69":{"apptype":"launch"},
    "70":{"apptype":"print","design_id":"21-21","angle":"0","media_type":"0","media_size":"0"},
    "71":{"apptype":"launch"},
    "72":{"apptype":"print","design_id":"41-21","angle":"0","media_type":"0","media_size":"0"},
    "73":{"apptype":"print","design_id":"04-01","angle":"0","media_type":"0","media_size":"0"},
    "77":{"apptype":"print","design_id":"13-22","angle":"0","media_type":"0","media_size":"0"},
    "78":{"apptype":"launch"},
    "79":{"apptype":"print","design_id":"06-01","angle":"0","media_type":"0","media_size":"0"},
    "80":{"apptype":"print","design_id":"31-41","angle":"0","media_type":"0","media_size":"0"},
    "81":{"apptype":"print","design_id":"06-03","angle":"0","media_type":"0","media_size":"0"},
    "82":{"apptype":"print","design_id":"53-42","angle":"0","media_type":"0","media_size":"0"},
    "83":{"apptype":"launch"},
    "84":{"apptype":"print","design_id":"06-01","angle":"0","media_type":"0","media_size":"0"},
    "85":{"apptype":"launch"},
    "86":{"apptype":"launch"},
    "87":{"apptype":"print","design_id":"21-42","angle":"0","media_type":"0","media_size":"0"},
    "88":{"apptype":"print","design_id":"12-01","angle":"0","media_type":"0","media_size":"0"},
    "89":{"apptype":"launch"},
    "90":{"apptype":"print","design_id":"06-03","angle":"0","media_type":"0","media_size":"0"},
    "91":{"apptype":"print","design_id":"53-01","angle":"0","media_type":"0","media_size":"0"},
    "92":{"apptype":"print","design_id":"04-01","angle":"0","media_type":"0","media_size":"0"},
    "93":{"apptype":"print","design_id":"57-11","angle":"0","media_type":"0","media_size":"0"},
    "95":{"apptype":"launch"},
    "96":{"apptype":"launch"},
    "97":{"apptype":"print","design_id":"04-01","angle":"0","media_type":"0","media_size":"0"},
    "98":{"apptype":"launch"},
    "99":{"apptype":"print","design_id":"01-53","angle":"0","media_type":"0","media_size":"0"},
    "101":{"apptype":"print","design_id":"04-01","angle":"0","media_type":"0","media_size":"0"},
    "102":{"apptype":"print","design_id":"04-54","angle":"0","media_type":"0","media_size":"0"},
    "108":{"apptype":"print","design_id":"12-01","angle":"0","media_type":"0","media_size":"0"},
    "109":{"apptype":"print","design_id":"06-01","angle":"0","media_type":"0","media_size":"0"},
    "114":{"apptype":"launch"},
    "115":{"apptype":"launch"},
    "116":{"apptype":"launch"},
    "117":{"apptype":"launch"},
    "118":{"apptype":"launch"},
    "121":{"apptype":"launch"},
    "122":{"apptype":"print","design_id":"21-21","angle":"0","media_type":"0","media_size":"0"},  
    "124":{"apptype":"launch"},
    "130":{"apptype":"launch"},
    "133":{"apptype":"launch"},
    "134":{"apptype":"launch"},
};

 export default APPLINK;